export const GET_CHECKIN_LIST = "GET_CHECKIN_LIST";
export const GET_PROMOTION_LIST = "GET_PROMOTION_LIST";
export const GET_REDEMPTION_LIST = "GET_REDEMPTION_LIST";
export const CHANGE_STATUS_REDEMPTION = "CHANGE_STATUS_REDEMPTION";
export const CHANGE_STATUS_PROMOTION = "CHANGE_STATUS_PROMOTION";
export const PROMO_STATUS_UNDEFINED = "PROMO_STATUS_UNDEFINED";
export const REDEMP_STATUS_UNDEFINED = "REDEMP_STATUS_UNDEFINED";
export const GET_CHECKOUT_HISTORY = "GET_CHECKOUT_HISTORY";
export const GET_CHECKOUT_HISTORY_SUMMARY = "GET_CHECKOUT_HISTORY_SUMMARY";
export const GET_STAFF_BY_SERVICE = "GET_STAFF_BY_SERVICE";
export const GET_CHECKOUT_INFO = "GET_CHECKOUT_INFO";
export const CHECKOUT_SUBMIT = "CHECKOUT_SUBMIT";
export const UPDATE_CUSTOMER_NOTE = "UPDATE_CUSTOMER_NOTE";
export const CHECK_PHONE = "CHECK_PHONE";
export const CHECKIN_SUBMIT = "CHECKIN_SUBMIT";
export const LOGIN = "LOGIN";
export const UPDATE_STAFF = "UPDATE_STAFF";
export const UPDATE_SERVICE = "UPDATE_SERVICE";
export const CHANGE_STATUS_SERVICE_SHOW_FULL = "CHANGE_STATUS_SERVICE_SHOW_FULL";
export const UPDATE_SERVICE_WITH_STAFF_AND_PRICE = "UPDATE_SERVICE_WITH_STAFF_AND_PRICE";
export const UPDATE_IN_SERVICE_STATUS = "UPDATE_IN_SERVICE_STATUS";
export const CHECK_UPDATE = "CHECK_UPDATE";
export const CHECKOUT_REDEEM = "CHECKOUT_REDEEM";
export const UPDATE_CUSTOMER_CHECKIN_STAFF = "UPDATE_CUSTOMER_CHECKIN_STAFF";
export const UPDATE_SMS_SENT = "UPDATE_SMS_SENT";
